import "./Footer.scss";

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer__reserved">
        &#169; 2021 ASGARD BEAUTY. ALL RIGHTS RESERVED.
      </p>
    </footer>
  );
}
